import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

/**
 * Single course-document scrollport: title header + body (+ copyright) scroll
 * together inside DocumentSplitShell / FlexibleLayout.
 */
export const StyledContent = styled('div')({
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  flex: '1 1 auto',
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  '@media print': {
    height: 'auto',
    overflow: 'visible',
  },
});

export const StyledHeaderButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ theme, isMobile }) => ({
  '& .MuiButton-startIcon': {
    marginRight: isMobile ? 0 : theme.spacing(1),
  },
  '& .btnText': {
    display: isMobile ? 'none' : 'block',
  },
}));
